import { useAppDispatch } from '@/Hook/hooks';
import { getDataAnalyticsConfig } from '@/Redux/Ducks/dataAnalyticsSlice';
import { getScreenConfig } from '@/Redux/Ducks/entryFormSlice';
import { getReportConfig } from '@/Redux/Ducks/reportExplorerSlice';
import { requestGetUserSearchObjects } from '@/Redux/Sagas/Requests/others';
import { ArrayKeyValueObject } from '@/UI/Interfaces/IBaseUI';
import React, { useEffect, useRef, useState } from 'react'
import SelectSearch from 'react-select-search'

const Search = () => {
  const dispatch = useAppDispatch();

  const searchInput: any = useRef<HTMLDivElement>(null);
  const [loaded, setLoaded] = useState<boolean>(false);
  const [objects, setObjects] = useState<any>([]);

  const loadData = async () => {
    if (!loaded) {
      var response: ArrayKeyValueObject = await requestGetUserSearchObjects();
      var userSearchObjects = Object.entries(response.groupBy("objecttype")).map(([objecttype, objects]: any) => {
        return {
          name: objecttype,
          type: "group",
          items: objects.map((object: any) => {
            let name = object.objectcontroller;

            if (!objecttype.isEqual("ENTRY FORM")) {
              var index = name.indexOf(" - ");
              name = name.substring(index + 3);
            }

            return { value: object.objectcontroller.split(" - ")[0] + " - " + object.objecttype, name }
          })
        }
      })

      setObjects(userSearchObjects);
      setLoaded(true);
    }
  }

  useEffect(() => {
    loadData();
  }, [loaded])

  const filterOptions = (groups: any) => {
    return (searchValue: any) => {
      if (searchValue.length === 0) {
        return objects;
      }
      const updatedItems = groups.map((items: any) => {
        const newItems = items.items.filter((item: any) => {

          const line = item.name.toLowerCase().trim();
          const searchText = searchValue.toLowerCase().trim();

          const searchArray: string[] = searchText.split(/\s+/);

          const findCount = searchArray.filter(x => line.includes(x));

          return findCount.length == searchArray.length;
        });
        return { ...items, items: newItems };
      });

      return updatedItems;
    };
  }

  const routeToObject = (objectcontrollerno: string, objecttype: string) => {
    switch (objecttype) {
      case "ENTRY FORM":
        dispatch(getScreenConfig({ processCode: objectcontrollerno }))
        break;
      case "DATA ANALYTICS":
        dispatch(getDataAnalyticsConfig({ dataAnalyticsno: objectcontrollerno }))
        break;
      case "REPORTS":
        dispatch(getReportConfig({ reportObjectno: objectcontrollerno }))
        break;
    }
  }

  const onSearchChange: any = (val: string) => {
    var objectcontrollerno = val.split(" - ")[0];
    var objecttype = val.split(" - ")[1].toUpperCase();
    routeToObject(objectcontrollerno, objecttype)
  };

  return (
    <SelectSearch
      ref={searchInput}
      className="header-search"
      options={objects}
      onChange={onSearchChange}
      search={true}
      autoComplete="on"
      filterOptions={filterOptions}
      placeholder="Search"
    />
  )
}

export default Search